// Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved.

import { valid_url } from 'src/app/app-data/constants/regex-patterns';

export const extractHostName = (linksStr: string) => {
	const linkStrVal =
		linksStr === ''
			? null
			: linksStr.split(',').map((link) => {
					const trimmedStr = link.trim();
					if (valid_url.test(trimmedStr)) {
						const url = new URL(trimmedStr);
						return url.hostname;
					} else {
						return trimmedStr;
					}
			  });
	return linkStrVal;
};
